var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { HeaderTabButton } from "./HeaderTabButton";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        height: theme.spacing(7) /* 仮：ヘッダーの高さは56pxで固定 */,
    },
}); }, { name: 'SnHeaderTabButtonGroup' });
export var HeaderTabButtonGroup = function (props) {
    var _a;
    var value = props.value, defaultValue = props.defaultValue, disabled = props.disabled, tabs = props.tabs, width = props.width, onChange = props.onChange, light = props.light, dark = props.dark, classNameProps = props.className, styleProp = props.style, classesProps = props.classes;
    var classes = useStyles(props);
    var _b = useState(defaultValue), selectedId = _b[0], setSelectedId = _b[1];
    var handleClickItem = useCallback(function (id) {
        setSelectedId(id);
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    }, [onChange]);
    var styles = useMemo(function () {
        return __assign({ width: width }, styleProp);
    }, [width, styleProp]);
    if (tabs == null || tabs.length === 0)
        return null;
    var displaySelectedId = (_a = value !== null && value !== void 0 ? value : selectedId) !== null && _a !== void 0 ? _a : tabs[0].id;
    var rootClassName = classNames(classes.root, classNameProps);
    return (React.createElement("div", { className: rootClassName, style: styles }, tabs.map(function (item) {
        return (React.createElement(HeaderTabButton, { key: item.id, id: item.id, icon: item.icon, name: item.name, selected: item.id === displaySelectedId, disabled: disabled, light: light, dark: dark, classes: classesProps, to: item.to, href: item.href, onClick: handleClickItem }));
    })));
};
